import { render, staticRenderFns } from "./TaxPlanIndex.vue?vue&type=template&id=152715a9&scoped=true"
import script from "./TaxPlanIndex.vue?vue&type=script&lang=js"
export * from "./TaxPlanIndex.vue?vue&type=script&lang=js"
import style0 from "./TaxPlanIndex.vue?vue&type=style&index=0&id=152715a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152715a9",
  null
  
)

export default component.exports